export default {
  label: {
    display: 'block',
    color: '#acacac',
    marginBottom: '3px'
  }
}
